import "./index.css";
import initWebpage from "./js-modules/initWebpage.js";

initWebpage();
